import { render, staticRenderFns } from "./CategoriaProgramaticaPage.vue?vue&type=template&id=e2c0e2dc"
import script from "./CategoriaProgramaticaPage.js?vue&type=script&lang=js&external"
export * from "./CategoriaProgramaticaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports